import {FormControl, FormField} from 'platform/components';

import {useGetVehicleClassesQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {ServiceVehicleFormType} from '../../../types/ServiceVehicleFormType';

interface VehicleClassFieldProps extends RequiredTestIdProps {
  control: FormControl<ServiceVehicleFormType>;
}

export function VehicleClassField(props: VehicleClassFieldProps) {
  const {data: vehicleClasses} = useGetVehicleClassesQuery();

  const vehicleClassOptions =
    vehicleClasses
      ?.filter((vehicleClass) => vehicleClass.isActive)
      .map((vehicleClass) => ({value: vehicleClass.vehicleClassId, label: vehicleClass.name})) ??
    [];

  return (
    <FormField
      control={props.control}
      type="choice"
      name="vehicleClassId"
      options={vehicleClassOptions}
      label={i18n.t('entity.vehicleClass.labels.vehicleClass')}
      tooltip={i18n.t('entity.vehicleClass.labels.vehicleClassTooltip')}
      data-testid={props['data-testid']}
    />
  );
}
